const CustomDot = ({ urls, onClick, ...rest }: any) => {
  const { index, active } = rest;

  return (
    <button
      type="button"
      className={`w-14 h-14 flex-shrink-0 rounded-md overflow-hidden border-2 
        hover:border-primary-blue-500 transition-colors p-1
        ${active ? 'border-primary-blue-500 opacity-100' : 'border-transparent opacity-60'}`}
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
    >
      <img
        src={urls[index]}
        alt={`Thumbnail ${index}`}
        className="w-full h-full object-contain rounded-md"
      />
    </button>
  );
};

export default CustomDot;
